module.exports = "<div ui-view\n  ng-cloak>\n\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./public/javascript/sygem/routing/consult/wagon/templates/index.html
// module id = 1532
// module chunks = 0